module.exports = __webpack_public_path__ + "img/3_67.66657ffd.png";